import { Injectable } from '@angular/core';
import { DataServices } from './data.services';
import { Banner } from '../models/banner.model';
import { LoggingService } from './LoggingService.service';

@Injectable()
export class BannersService{

   banners: Banner[] = [];
  bannersHomePage: Banner[] = [];

  constructor(private loggingService: LoggingService, private dataServices: DataServices){}

  getBanners(idCard: number) {
    return this.dataServices.getBanners(idCard);
 }

 setBanners(banners: Banner[]) {
    this.banners =  banners;
 }


  getBannersHomePage() {
    return this.dataServices.getBannersHomePage();
  }

  setBannersHomePage(banners: Banner[]) {
    this.bannersHomePage =  banners;
  }

}
